function mapToRange(val: number, in_min: number, in_max: number, out_min: number, out_max: number): number {
    return ((val - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
}

declare interface Number {
    mod(n: number) : number;
}

Number.prototype.mod = function (n: number): number {
    return ((this as number % n) + n) % n;
};

const mediaContainer = document.querySelector(".media-container") as  HTMLElement;
const mediaFiles: HTMLMediaElement[] = [];
let activeSong: HTMLMediaElement;

const player = mediaContainer?.querySelector(".player-container") as HTMLElement;
const info = player.querySelector(".info") as HTMLElement;
const prevBtn = player.querySelector("input[name='prev']") as HTMLInputElement;
const playBtn = player.querySelector("input[name='play']") as HTMLInputElement;
const nextBtn = player.querySelector("input[name='next']") as HTMLInputElement;
const loopBtn = player.querySelector("input[name='loop']") as HTMLInputElement;
const trackLengthContainer = player.querySelector(".length-container") as HTMLElement;
const trackLength = trackLengthContainer?.querySelector(".length") as HTMLElement;
let locked = false;

function play() {
    locked = true;
    if (playBtn?.checked) {
        info.innerHTML = activeSong.getAttribute("data-name") as string;
        console.log("start:", info.innerHTML);
        const play =  activeSong.play();
        if(play !== undefined) {
            play.then(() => {
                locked = false;
                window.history.pushState(
                    {additionalInformation: 'Updated URL'},
                        "Jani Holli | " + info.innerHTML,
                        "music?song=" + activeSong.getAttribute("data-id")
                );
                console.log("playing", info.innerHTML);
            }).catch((err) => {
                activeSong.pause();
                playBtn.checked = false;
                locked = false;
                console.log(err);
            });
        }
        (activeSong.parentNode as HTMLDivElement).classList.add("song-active");
    } else {
        activeSong.pause();
        locked = false;
    }
}

function prev(e: MouseEvent) {
    if(!locked) {
        activeSong.pause();
        activeSong.currentTime = 0;
        const id = (mediaFiles.indexOf(activeSong) - 1).mod(mediaFiles.length);
        (activeSong.parentNode as HTMLDivElement).classList.remove("song-active");
        activeSong = mediaFiles[id];
        playBtn.checked ? false : (playBtn.checked = true);
        play();
        prevBtn.checked = false;
    }
}

function next(e: MouseEvent) {
    if(!locked) {
        activeSong.pause();
        activeSong.currentTime = 0;
        const id = (mediaFiles.indexOf(activeSong) + 1).mod(mediaFiles.length);
        (activeSong.parentNode as HTMLDivElement).classList.remove("song-active");
        activeSong = mediaFiles[id];
        playBtn.checked ? false : (playBtn.checked = true);
        play();
        nextBtn.checked = false;
    }
}

function move(e: MouseEvent) {
    if(!locked) {
        const rect = (e.target as HTMLElement).getBoundingClientRect();
        const x = e.clientX - rect.left;
        activeSong.pause();
        activeSong.currentTime = mapToRange(
            x,
            0,
            trackLengthContainer.clientWidth,
            0,
            activeSong.duration
        );
        play();
    }
}

function playTrack(media: HTMLMediaElement) {
    if(!locked) {
        (activeSong.parentNode as HTMLElement).classList.remove("song-active");
        activeSong.pause();
        activeSong.currentTime = 0;
        activeSong = media;
        activeSong.currentTime = 0;
        playBtn.checked = true;
        play();
    }
}

console.log(playBtn);

playBtn.onclick = play;
prevBtn.onclick = prev;
nextBtn.onclick = next;
trackLengthContainer.onclick = move;

const songs = document.querySelectorAll(".song-container");
for (let i = 0; i < songs.length; i++) {
    const song = songs[i];
    const name = song.querySelector("p") as HTMLParagraphElement;
    const media = song.querySelector("audio") as HTMLMediaElement;
    const src = media.querySelector("source") as HTMLSourceElement;
    let fileName = src.src.split("/") as any;
    fileName = fileName[fileName.length-1];
    media.setAttribute("data-name", name?.innerHTML);
    media.setAttribute("data-id", fileName);
    media.controls = false;
    media.ontimeupdate = (e) => {
        const min = Math.floor(media.currentTime/60);
        const sec = Math.floor(media.currentTime % 60);
        info.setAttribute("data-time", min.toString() + ":" + (sec<10?"0":"") + sec.toString());
        trackLength.style.width =
            mapToRange(media.currentTime, 0, media.duration, 0, 100) + "%";
    };
    media.onended = (e) => {
        if (loopBtn.checked) {
            nextBtn.click();
        } else {
            playBtn.checked = false;
        }
    };
    mediaFiles.push(media);
    name.onclick = () => playTrack(media);
}

function init() {
    const params = new URLSearchParams(window.location.search);
    const song = params.get('song');
    const songMedia = document.querySelector('audio[data-id="' + song + '"]') as HTMLMediaElement;
    console.log(songMedia);
    playTrack(songMedia ? songMedia : mediaFiles[0]);
}

activeSong = mediaFiles[0];

window.onload = init;
window.onpopstate = init;

export {}
